// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__rKIn_","error":"InputSecondary_error__ON5CW","disabled":"InputSecondary_disabled__3lazd"};